export function getPageInfo(state) {
  return state.infoPage;
}

export function getStateLoadPage(state) {
  return state.loadPage;
}
